import React from 'react';
import cx from 'classnames';

import TableCell from './TableCell';

import styles from './TableRowExpanded.module.scss';

export interface TableRowExpandedProps
  extends React.HTMLProps<HTMLTableRowElement> {
  /** Child of `Table.RowExpanded` which can be any element. */
  children: React.ReactNode;
  /** If true, expanded content will appear. */
  isExpanded?: boolean;
  /** Dictate how many columns the cell will span. */
  colSpan?: number;
  /** Add a CSS class for cell.*/
  cellWrapperClassName?: Parameters<typeof cx>[0];
}

export const TableRowExpanded: React.FC<TableRowExpandedProps> = ({
  children,
  isExpanded = false,
  colSpan = 1,
  cellWrapperClassName,
  ...rest
}) => {
  if (isExpanded) {
    return (
      <tr {...rest} className={cx(styles.rowExpanded)}>
        <TableCell colSpan={colSpan} className={cx(cellWrapperClassName)}>
          {children}
        </TableCell>
      </tr>
    );
  }

  return null;
};

export default TableRowExpanded;
export { styles };
